import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartnerFormBasic } from 'clickNgo/entities/partner/models/form/basic'
import { IPartnerFormLegal } from 'clickNgo/entities/partner/models/form/legal'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { THierarchyTypeSource } from './models'

export const hierarchyTypeSource = new Crud({
  fetcher: new Static<THierarchyTypeSource>(
    Object.values(PartnerHierarchyType)
      .filter((value) => value !== PartnerHierarchyType.SUBSIDIARY)
      .map((title, id) => ({
        id,
        title,
      }))
  ),
  keyField: 'title',
})

export const hierarchyTypeListWithCopyData: PartnerHierarchyType[] = [
  PartnerHierarchyType.BRANCH,
  PartnerHierarchyType.ONLINE,
  PartnerHierarchyType.AFFILIATE,
  PartnerHierarchyType.RESELLER_NETWORK,
]

export const fieldsToResetAfterHierarchyTypeChange: {
  basic: (keyof IPartnerFormBasic)[]
  legal: (keyof IPartnerFormLegal)[]
} = {
  basic: ['country', 'taxId', 'url', 'phoneCountryCode', 'region'],
  legal: [
    'companyLegalName',
    'companyEnglishName',
    'legalAddressLine1',
    'legalAddressLine2',
    'legalAddressLine3',
    'legalCountry',
    'legalState',
    'legalCity',
    'legalZipCode',
  ],
}

export const fieldsCopyFromHQ: {
  [key in PartnerHierarchyType]: {
    basic: (keyof IPartnerFormBasic)[]
    legal: (keyof IPartnerFormLegal)[]
  }
} = {
  [PartnerHierarchyType.BRANCH]: {
    basic: ['country', 'taxId', 'url'],
    legal: [
      'companyLegalName',
      'companyEnglishName',
      'legalAddressLine1',
      'legalAddressLine2',
      'legalAddressLine3',
      'legalCountry',
      'legalState',
      'legalCity',
      'legalZipCode',
    ],
  },
  [PartnerHierarchyType.ONLINE]: {
    basic: ['country', 'taxId', 'url'],
    legal: [
      'companyLegalName',
      'companyEnglishName',
      'legalAddressLine1',
      'legalAddressLine2',
      'legalAddressLine3',
      'legalCountry',
      'legalState',
      'legalCity',
      'legalZipCode',
    ],
  },
  [PartnerHierarchyType.AFFILIATE]: {
    basic: [],
    legal: ['companyEnglishName'],
  },
  [PartnerHierarchyType.RESELLER_NETWORK]: {
    basic: [],
    legal: ['companyEnglishName'],
  },
  [PartnerHierarchyType.HEADQUARTERS]: {
    basic: [],
    legal: [],
  },
  [PartnerHierarchyType.SUBSIDIARY]: {
    basic: [],
    legal: [],
  },
}

export const AFFILIATE_AND_RESELLER_BUYER_TYPE_ALLOWED = [
  '_vdm',
  '_var',
  '_cso',
  '_daa',
  '_dab',
  '_dlr',
]
